import React from 'react';
import { Linking, Platform } from 'react-native';
import { createStyleSheet } from '../../../../utils';
import { useStyleSheet } from '../../../../hooks';
import { Text as UIText } from '../../../Text';
export const Text = ({ value, style, href }) => {
    const styles = useStyleSheet(getStyles);
    return (React.createElement(UIText, Object.assign({ type: 'body', size: 'md', weight: 'regular', selectable: true }, (href
        ? {
            onPress: () => {
                void Linking.openURL(href);
            }
        }
        : {}), { style: [
            style
                ? Object.keys(style).reduce((acc, v) => (style[v] === true ? [...acc, styles[v]] : acc), [])
                : null,
            href ? styles.link : styles.text
        ] }), value));
};
const getStyles = createStyleSheet(({ color }) => ({
    bold: {
        fontWeight: 'bold'
    },
    italic: {
        fontStyle: 'italic'
    },
    underline: {
        textDecorationLine: 'underline'
    },
    strike: {
        textDecorationLine: 'line-through'
    },
    link: {
        color: color.primary.solid,
        textDecorationLine: 'underline'
    },
    // @ts-expect-error following is web specific prop
    text: Object.assign({}, (Platform.OS === 'web' ? { cursor: 'text' } : {}))
}));
//# sourceMappingURL=Text.js.map